import {FC, ReactNode, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  activateGhlIntegration,
  deactivateGhlIntegration,
  fetchActiveIntegrationApp,
  getActivateIntegrationByUser,
  getIntegrationRefetchDataStatus,
  resetSelectedIntegrationData,
} from '../IntegrationSlice/IntegrationSlice'
import {Form, Button, Accordion, Card, Row, Col} from 'react-bootstrap'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ExternalProvider} from '../IntegrationSlice/Types'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useLazyGetSendersQuery} from '../../../../../services/cellcast.v2'
import Select from 'react-select'
import {
  useActivateIntegrationAppMutation,
  useDeactivateIntegrationAppMutation,
  useUpdateGhlSenderMutation,
  useUpdateIntegrationAppDataMutation,
} from '../../../../../services/cellcast'
import {SenderCamp} from '../../../../../services/cellcast.type'
import {findIndex} from 'lodash'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  getApikeyListData,
  getApiKeysListOfuser,
} from '../../accounts/ApiKeys/ApikeysSlices/ApiKeysSlices'

interface Stirpe {
  selectedExternalProvider: ExternalProvider
  userData: any
}

const API_URL = ENV().REACT_APP_API_URL

// Define props types for Step and SubStep components
interface StepProps {
  title: string
  children: ReactNode
}

const Step: React.FC<StepProps> = ({title, children}) => (
  <div className='step'>
    <h2>{title}</h2>
    {children}
  </div>
)

const List: React.FC<{items: string[]}> = ({items}) => (
  <ul>
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
)

const Make: FC<Stirpe> = ({selectedExternalProvider, userData}) => {
  let userId = ''
  if (userData && userData.user) {
    if (userData.user._id !== userData.user.ownerId && !userData.user.subClientAccountId) {
      userId = userData.user.ownerId
    } else {
      userId = userData.user._id
    }
  }
  const apikeyListData = useSelector(getApikeyListData)

  const selectedActiveIntegration = useSelector(
    getActivateIntegrationByUser(userId, selectedExternalProvider._id)
  )
  const token =
    apikeyListData?.length > 0 ? apikeyListData?.find((el: any) => el.name === 'stripe') : null

  const [activateIntegration] = useActivateIntegrationAppMutation()
  const [deactivateIntegration] = useDeactivateIntegrationAppMutation()

  const [updateIntegrationData, {isLoading: updateIntegrationDataLoading}] =
    useUpdateIntegrationAppDataMutation()
  const refetch = useSelector(getIntegrationRefetchDataStatus)
  const globalLoading = useSelector(isLoading)

  const dispatch = useDispatch()

  const [value, setValue] = useState<{eventType: string; message: string}[]>([])

  // load data when first load
  useEffect(() => {
    if (selectedExternalProvider._id) {
      dispatch(resetSelectedIntegrationData)
      dispatch(fetchActiveIntegrationApp())
    }
  }, [selectedExternalProvider])

  useEffect(() => {
    dispatch(getApiKeysListOfuser())
  }, [])

  useEffect(() => {
    if (selectedActiveIntegration && selectedActiveIntegration.data) {
      if (selectedActiveIntegration.data?.stripe) {
        setValue(selectedActiveIntegration.data?.stripe)
      }
    }
  }, [selectedActiveIntegration])

  useEffect(() => {
    if (refetch) {
      dispatch(fetchActiveIntegrationApp())
    }
  }, [refetch])

  // handle delete
  const [isOpenDeactivateConfirmation, setIsOpenDeactivateConfirmation] = useState(false)
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const onClickDeactivateHandler = () => {
    setIsOpenDeactivateConfirmation(true)
  }

  const onClickActivateHandler = () => {
    activateIntegration({
      integrationProviderName: 'Make.com',
    })
      .unwrap()
      .then((res) => {
        toast.success(res?.message)
        dispatch(fetchActiveIntegrationApp())
        dispatch(fetchAsyncUserDetails())
        dispatch(getApiKeysListOfuser())
      })
  }

  const onUpdateData = () => {
    updateIntegrationData({data: value, integrationProviderName: 'Make.com'})
      .unwrap()
      .then((res) => {
        toast.success(res?.data?.message)
        dispatch(fetchActiveIntegrationApp())
        dispatch(getApiKeysListOfuser())
      })
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenDeactivateConfirmation}
        handleClose={() => setIsOpenDeactivateConfirmation(false)}
        Message={'Are you sure, you want to deactivate integration ?'}
        confirm={() => setIsDeleteConfirm(true)}
        confirmBtnTitle='Yes, deactivate'
      />
    ),
    [isOpenDeactivateConfirmation]
  )

  useEffect(() => {
    if (isDeleteConfirm === true) {
      deactivateIntegration({
        integrationProviderName: 'Make.com',
      })
        .unwrap()
        .then((res) => {
          setIsDeleteConfirm(false)
          setIsOpenDeactivateConfirmation(false)
          dispatch(fetchActiveIntegrationApp())
          dispatch(fetchAsyncUserDetails())
          toast.success(res?.message)
        })
    }
  }, [isDeleteConfirm])

  return (
    <div className='card p-7 pb-lg-4 p-lg-10'>
      {confirmation}
      <h1>Detail Integration</h1>
      <div className='row'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div
                className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
                style={{
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  borderRadius: 5,
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderWidth: 1,
                }}
              >
                {selectedExternalProvider?.image == '' || selectedExternalProvider == undefined ? (
                  <span
                    className='squere1'
                    style={{
                      width: '100px',
                      height: '100px',
                    }}
                  >{`${
                    selectedExternalProvider?.name !== undefined &&
                    selectedExternalProvider?.name !== ''
                      ? selectedExternalProvider?.name.split('')?.[0]?.toUpperCase() ?? 'C'
                      : 'EP'
                  }`}</span>
                ) : (
                  <img src={selectedExternalProvider.image} alt='stripe' />
                )}
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                    selectedActiveIntegration ? ' bg-success ' : 'bg-danger'
                  }`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <span className='text-gray-800 fs-2 fw-bolder me-1 mb-10'>
                {selectedExternalProvider?.name ?? 'Undefined'}
              </span>
              {selectedActiveIntegration ? (
                <div className='mt-5'>
                  <Form.Group className='mb-10'>
                    <Form.Group className='mb-10'>
                      <Form.Label>Api Key Label</Form.Label>
                      <Form.Control
                        type='text'
                        disabled
                        value={selectedActiveIntegration?.internalApiKeyName}
                      />
                    </Form.Group>
                    <Form.Group className='mb-10'>
                      <Form.Label>Api Key </Form.Label>
                      <Form.Control as='textarea' rows={3} disabled value={token?.token || ''} />
                    </Form.Group>

                    <div>
                      <span className='text-muted'>Visit </span>
                      <Link to='/accounts/api-keys'>
                        <b>api page</b>
                      </Link>
                      <span className='text-muted'> for more detail </span>
                    </div>
                  </Form.Group>

                  <Accordion className='mb-10'>
                    <Accordion.Item eventKey='0'>
                      <Accordion.Header>Integration Step</Accordion.Header>
                      <Accordion.Body>
                        <div
                          style={{
                            margin: '0 auto',
                            fontFamily: 'Arial, sans-serif',
                          }}
                        >
                          <h1>Steps to Connect Cellcast with Make.com</h1>

                          <Step title='Create a Trigger Action'>
                            <p>To create a trigger action, follow these steps:</p>
                            <ul>
                              <li>
                                <strong>Add a module and Setup Webhook</strong>
                              </li>
                              <li>
                                Choose <strong>Custom Trigger Webhook</strong> and use the provided
                                URL to push data to the webhook.
                              </li>
                            </ul>
                          </Step>

                          <Step title='Add Cellcast Task/Module'>
                            <p>Select one of the following Enterprise Cellcast actions:</p>
                            <ul>
                              <li>Create a Contact</li>
                              <li>Send SMS</li>
                              <li>Send MMS</li>
                            </ul>
                          </Step>

                          <Step title='1. Create a Contact'>
                            <ul>
                              <li>
                                <strong>Add a Connection</strong> or use an existing one:
                              </li>
                              <ul>
                                <li>
                                  Create a new API key under{' '}
                                  <strong>Settings &gt; API Setup</strong> in your Cellcast account,
                                  or use an existing key.
                                </li>
                                <li>
                                  Copy the API key and paste it into the <strong>APP KEY</strong>{' '}
                                  field in Make.com to establish the connection.
                                </li>
                              </ul>
                              <li>
                                Select data from the webhook response (e.g., first name, last name,
                                phone number).
                              </li>
                              <li>
                                Click <strong>Run Once</strong> to test the module, and test the
                                entire scenario after configuring all modules.
                              </li>
                            </ul>
                          </Step>

                          <Step title='2. Send SMS'>
                            <ul>
                              <li>
                                <strong>Add a Connection</strong> or use an existing one:
                              </li>
                              <ul>
                                <li>
                                  Create a new API key under{' '}
                                  <strong>Settings &gt; API Setup</strong> in Cellcast, or use an
                                  existing one.
                                </li>
                                <li>
                                  Copy the API key and paste it into the <strong>APP KEY</strong>{' '}
                                  field in Make.com.
                                </li>
                              </ul>
                              <li>
                                Select data from the webhook response (e.g., message, contacts like
                                "number1", "number2", and sender).
                              </li>
                              <li>
                                Click <strong>Run Once</strong> to test the module, and test the
                                entire scenario after configuring all modules.
                              </li>
                            </ul>
                          </Step>

                          <Step title='3. Send MMS'>
                            <ul>
                              <li>
                                <strong>Add a Connection</strong> or use an existing one:
                              </li>
                              <ul>
                                <li>
                                  Create a new API key under{' '}
                                  <strong>Settings &gt; API Setup</strong> in Cellcast, or use an
                                  existing one.
                                </li>
                                <li>
                                  Copy the API key and paste it into the <strong>APP KEY</strong>{' '}
                                  field in Make.com.
                                </li>
                              </ul>
                              <li>
                                Select data from the webhook response (e.g., message, contacts,
                                sender, and the attachment URL).
                              </li>
                              <li>
                                Click <strong>Run Once</strong> to test the module, and test the
                                entire scenario after configuring all modules.
                              </li>
                            </ul>
                          </Step>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Button
                    variant='danger'
                    type='submit'
                    disabled={globalLoading}
                    onClick={() => onClickDeactivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Deactivate'
                    )}
                  </Button>
                </div>
              ) : (
                <div className='mt-20'>
                  <Button variant='primary' type='button' onClick={() => onClickActivateHandler()}>
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Activate'
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Make}
